import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampOperator';

const CampOperatorApi: any = baseApi(endpoint);

export default CampOperatorApi;